var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNews(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 160 160",
    style: {
      enableBackground: "new 0 0 160 160"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#000000;stroke-width:5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#000000;stroke-width:5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Haut_parleur"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M108.7,48.5c0,0,10.8,27,0.1,60.6l-0.6,0.3C47.7,88.2,18,96.7,18,96.7l-0.3-0.2c-10.1-22.7,0-35.3,0-35.3 s29.8,8.4,90.3-12.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M107,49.1c0,0-7.2,26.5-0.1,59.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "37.4,95.5 37.4,111.7 48.1,111.7 48.1,103.2  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 123.2,
    y1: 64.6,
    x2: 150.5,
    y2: 46.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 125.7,
    y1: 79.6,
    x2: 139.3,
    y2: 79.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 150.5,
    y1: 112.4,
    x2: 123.2,
    y2: 94.7
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews);
export default __webpack_public_path__ + "static/media/news.4d16fe37f077b411566581c875fdc1e9.svg";
export { ForwardRef as ReactComponent };